import { Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

interface StyledHeaderMobileProps {
  isTransparent?: boolean;
}

/**
 * Main mobile header container
 */
export const StyledHeaderMobile = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isTransparent',
})<StyledHeaderMobileProps>(({ theme, isTransparent }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  minHeight: theme.spacing(19),
  borderBottom: `1px solid`,
  borderColor: theme.palette.text.fourth,
  background: isTransparent ? 'transparent' : theme.palette.background.default,
  paddingInline: theme.spacing(4),
}));

/**
 * Left section - menu, discord, youtube
 */
export const StyledMobileLeftSection = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
});

/**
 * Right section - actions and profile
 */
export const StyledMobileRightSection = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginLeft: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down(430)]: {
    gap: theme.spacing(2),
  },
}));
